import { ChangeDetectionStrategy, Component, effect, inject, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CurrencyInfo } from '@app/generated-api';
import { RequestType } from '@app/v2/enums/request-types.enum';
import { MdsDialogComponent, MdsDialogContentComponent } from '@medpacesoftwaredevelopment/designsystem';
import { PaymentRequestStatus } from '@models/request';
import { ModalSize } from '@utility/modal-helper';
import { PaymentRequestStatusChangeModalContentComponent } from './payment-request-status-change-modal-content/payment-request-status-change-modal-content.component';
import { PaymentRequestStatusChangeFormGroup } from './payment-request-status-change-modal-content/payment-request-status-change-modal-content.form';

export type PaymentRequestStatusChangeModalComponentData = {
    requestType: RequestType;
    requestId: number;
};

export type PaymentRequestStatusChangeModalComponentResult = {
    newStatus: string;
    additionalInfo: string;
    deducted: Partial<{
        deducted: number;
        deductedUsd: number;
        deductedCurrency: CurrencyInfo;
    }>;
};

@Component({
    selector: 'medpace-payment-request-status-change-modal',
    imports: [MdsDialogComponent, MdsDialogContentComponent, PaymentRequestStatusChangeModalContentComponent],
    templateUrl: './payment-request-status-change-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentRequestStatusChangeModalComponent {
    dialogRef = inject<
        MatDialogRef<PaymentRequestStatusChangeModalComponent, PaymentRequestStatusChangeModalComponentResult>
    >(MatDialogRef<PaymentRequestStatusChangeModalComponent, PaymentRequestStatusChangeModalComponentResult>);
    data = inject<PaymentRequestStatusChangeModalComponentData>(MAT_DIALOG_DATA);

    modalContentRef = viewChild.required(PaymentRequestStatusChangeModalContentComponent);

    formGroup = new PaymentRequestStatusChangeFormGroup();

    changeModalSize = effect(() => {
        if (this.modalContentRef().modalContent().deductedForm) {
            this.dialogRef.updateSize(ModalSize.Medium);
        } else {
            this.dialogRef.updateSize(ModalSize.Small);
        }
    });

    cancel() {
        this.dialogRef.close();
    }
    confirm(formGroup: PaymentRequestStatusChangeFormGroup) {
        const value = formGroup.getRawValue();
        this.dialogRef.close({
            newStatus: PaymentRequestStatus[value.newStatusId!],
            additionalInfo: value.additionalInfo,
            deducted: {
                deducted: value.deductedFormGroup?.deducted ?? undefined,
                deductedUsd: value.deductedFormGroup?.deductedUsd ?? undefined,
                deductedCurrency: value.deductedFormGroup?.deductedCurrency ?? undefined,
            },
        });
    }
}
